import { PERSON_TYPES } from "@letsbit/malcolmlb";
import {
  MemberStatusWithExtra,
  useGetMemberStatus,
} from "hooks/compliance/useGetMemberStatus";
import { ApiContext } from "providers/ApiProvider";
import { useCallback, useContext, useEffect, useState } from "react";

export const useIntroducingBrokerDashboardPage = () => {
  const { data: memberStatus } = useGetMemberStatus();
  const { memberInstance } = useContext(ApiContext);
  const [name, setName] = useState<string>();

  const getName = useCallback(
    async (memberStatus: MemberStatusWithExtra) => {
      try {
        if (memberStatus.customer?.person_type === PERSON_TYPES.JURIDICAL) {
          const { data: jpd } =
            await memberInstance.compliance.getJuridicalPerson();
          setName(jpd.company_name);
        }
        if (memberStatus.customer?.person_type === PERSON_TYPES.NATURAL) {
          const { data: npd } =
            await memberInstance.compliance.getNaturalPerson();
          setName(npd.first_name);
        }
      } catch (error) {
        console.error(error);
      }
    },
    [memberInstance.compliance],
  );

  useEffect(() => {
    if (memberStatus) {
      getName(memberStatus);
    }
  }, [memberStatus, getName]);

  return {
    name: name,
  };
};
